
<loading-bar></loading-bar>
<app-student-topbar></app-student-topbar>
<router-outlet></router-outlet>
     <!--start back-to-top-->
   <button (click)="topFunction()" class="btn btn-info btn-icon landing-back-top" id="back-to-top">
       <i class="ri-arrow-up-line"></i>
   </button>

<app-student-footer></app-student-footer>